import { RouteObject } from 'react-router';

import { createAppDetailRoutes } from './appDetails';
import { AppListPage } from './appList'

export function createAppRoutes(): RouteObject[] {
  const appDetailsRoutes = createAppDetailRoutes();
  return [
    {
      path: '',
      children: [
        {
          path: '',
          element: <AppListPage />,
        },
        ...appDetailsRoutes,
      ]
    }
  ];
}
